import { Card, Text } from '@nike/eds'
import classNames from 'classnames'
import '../Shipment.scss'

export interface ShipmentStatusCodeProps {
  status: string
}

export function ShipmentStatusCode({ status }: ShipmentStatusCodeProps) {
  return (
    <Card
      className={classNames(
        'shipment-status',
        'eds-card',
        'eds-spacing--p-8',
        status?.toLowerCase()
      )}
    >
      <Text>{status && status.replace('_', ' ')}</Text>
    </Card>
  )
}
